// extracted by css-extract-rspack-plugin
export default {"panel-header":"T4ldA96ifLAN67hu","panelHeader":"T4ldA96ifLAN67hu"};